<template>
  <router-link
    :to="{
      name: 'master-view',
      params: { id: teacher.id },
    }"
    class="d-flex flex-column align-items-center"
  >
    <div
      class="teacher-image"
      :style="`background: url(${teacher.photo}), rgb(79, 79, 79); background-size: cover; background-position: center;`"
    >
      <!-- <img
        v-if="teacher.photo || teacher.cover"
        :src="teacher.photo || teacher.cover"
        :alt="teacher.name"
        class="img-fluid"
        width="116"
        height="116"
      /> -->
      <div v-if="!teacher.photo" class="initals">
        {{ initials(teacher.name) }}
      </div>
    </div>

    <div class="mt-3 teacher-name">
      {{ teacher.name }}
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    teacher: {
      required: true,
      type: Object,
    },
  },
  methods: {
    initials(name) {
      return (
        name &&
        name
          .split(" ")
          .map((word) => word[0])
          .join("")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.teacher-image {
  border: 5px solid #333333;
  border-radius: 50%;
  width: 116px;
  height: 116px;
  transition: all 0.3s;
  position: relative;

  &:hover {
    border-color: $primary;
  }

  img {
    border-radius: 50%;
  }

  .initals {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 30px;
    font-weight: bold;
  }
}

.teacher-name {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;

  color: #828282;
}
</style>
